module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_sunshouse_03-0244c309d24301da50a5152bc5c88fb4.png";